import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./OperationsDrawerItemsMain";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import OperationsManagementScreen from "../../../screens/Operations/OperationsManagementScreen";
import ManageOperations from "../../../screens/Operations/ManageOperations";
import PlaceOrderScreen from "../../../screens/Operations/PlaceOrderScreen";
import SingleOperationScreen from "../../../screens/Operations/SingleOperationScreen";
import { useTranslation } from "../../../utils/useTranslation";
import { useAppTheme } from "../../../hooks/useAppTheme";


const Drawer = createDrawerNavigator();

export default function OperationsDrawerNavigator() {
  const { colors } = useAppTheme();
  const { t } = useTranslation();
  const dimensions = useWindowDimensions();
  return (
    <Drawer.Navigator
      screenOptions={{
        headerTintColor: colors.text,
        headerStyle: {
          backgroundColor: colors.surface,
          borderBottomWidth: 1,
          borderBottomColor: colors.border,
        },
        headerTitleStyle: {
          color: colors.text,
        },
        tabBarStyle: {
          backgroundColor: colors.surface,
          borderTopColor: colors.border,
        },
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={drawerItemsMain} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: t("operationsManagement"),
          title: t("operationsStatus"),
          headerShown: false,
        }}
        name="OperationsManagement"
        component={OperationsManagementScreen}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("manageOperations"),
          title: t("orderRequest"),
          headerShown: false,
        }}
        name="ManageOperations"
        component={ManageOperations}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("addOperations"),
          title: t("placeOrderRequest"),
          headerShown: false,
        }}
        name="PlaceOrder"
        component={PlaceOrderScreen}
        initialParams={{
          mode: "add",
          requestType: "place",
          operation: {},
          titleToDisplay: "Place Order Request",
        }}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("addOperations"),
          title: t("reserveOrderRequest"),
          headerShown: false,
        }}
        name="ReserveOrder"
        component={PlaceOrderScreen}
        initialParams={{
          mode: "add",
          requestType: "reserve",
          operation: {},
          titleToDisplay: "Reserve Order Request",
        }}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("addOperations"),
          title: t("prepayOrderRequest"),
          headerShown: false,
        }}
        name="PrepayOrder"
        component={PlaceOrderScreen}
        initialParams={{
          mode: "add",
          requestType: "prepay",
          operation: {},
          titleToDisplay: "Prepay Order Request",
        }}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("operationsDetails"),
          title: t("operationsDetails"),
          headerShown: false,
        }}
        name="SingleOperation"
        component={SingleOperationScreen}
        initialParams={{ order: {} }}
      />
    </Drawer.Navigator>
  );
}
